const InputField = (props) => {
  const inputProps = { ...props, type: props.type || "text" };
  return <input {...inputProps} className="form-control " />;
};

export default InputField;
